/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAllUsers } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { User } from "../types/userTypes";

export default function useUsers(
  callBack?: (data: User[]) => void,
  filters: Record<string, any> = {}
) {
  const query = useQuery<User[]>({
    queryKey: ["users", filters],
    queryFn: async () => {
      const res = await axiosInstance.get(getAllUsers, { params: filters });
      return res.data.users;
    },
    // Keep the previous user list rendered while a new query (e.g. search
    // keystroke) is in flight, so the page doesn't flash skeletons between
    // every search refinement.
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });

  useEffect(() => {
    if (query.data && callBack) {
      callBack(query.data);
    }
  }, [query.data, callBack]);

  return {
    users: query.data,
    length: query.data ? query.data.length : 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
